<template>
  <div>
    <el-carousel height="300px">
      <el-carousel-item v-for="(item) in slideImgs" :key="item">
        <img
          class="carousel-item-img"
          :src="item"
          alt=""
        >
      </el-carousel-item>
    </el-carousel>

    <!-- 新闻 ｜ 政策 ｜ 查询 -->
    <div
      class="d-flex justify-content-between"
      style="margin-top: 20px;"
    >
      <div class="home-module">
        <h3 class="clearfix">
          <span class="title fl">新闻资讯</span>
          <router-link :to="{path:'/news',query:{channelId: '5'}}">
            <a
              href="javascript:;"
              class="more fr"
            >更多 &gt;&gt;</a>
          </router-link>
        </h3>
        <ul>
          <li
            v-for="item in newsList"
            :key="item.id"
          >
            <router-link class="d-flex" :to="{path:'/newsDetail', query:{channelId: '5', newsId: item.id}}">
              <div class="flex-fill content">
                {{item.title}}
              </div>
              <div class="flex-0 d-flex flex-column text-center time">
                <span>{{item.publishDate | formatDay}}</span>
                <p>{{item.publishDate | formatDate}}</p>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="home-module">
        <h3 class="clearfix">
          <span class="title fl">政策法规</span>
          <router-link :to="{path:'/news',query:{channelId: '6'}}">
            <a
              href="javascript:;"
              class="more fr"
            >更多 &gt;&gt;</a>
          </router-link>
        </h3>
        <ul>
          <li
            v-for="item in policyList"
            :key="item.id"
          >
            <router-link class="d-flex" :to="{path:'/newsDetail', query:{channelId: '6', newsId: item.id}}">
            <div class="flex-fill content">
              {{item.title}}
            </div>
            <div class="flex-0 d-flex flex-column text-center time">
              <span>{{item.publishDate | formatDay}}</span>
              <p>{{item.publishDate | formatDate}}</p>
            </div>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="home-module">
        <h3><span class="title">溯源查询</span></h3>
        <div style="margin-top: 20px;">
          <el-form
            ref="refSearchForm"
            :model="searchForm"
            :rules="searchFormRules"
            label-width="120px"
            size="medium"
          >
            <el-form-item label="溯源码：" prop="traceCode">
              <el-input v-model="searchForm.traceCode"></el-input>
            </el-form-item>
            <el-form-item label="批次编码：" prop="batchCode">
              <el-input v-model="searchForm.batchCode"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="imgCode">
              <el-input
                type="text"
                auto-complete="off"
                v-model="searchForm.imgCode"
              >
                <img slot="append" :src="codeSrc" />
              </el-input>
            </el-form-item>
            <el-form-item>
              <div class="text-right">
                <el-button>清空</el-button>
                <el-button type="primary" @click="searchTrace">立即查询</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <!-- 图片 -->
    <img
      style="display: block; height: 100px; width: 100%; margin: 20px 0;"
      :src="bannerImg"
      alt=""
    >

    <div class="home-module fill">
      <h3><span class="title">农产品品牌</span></h3>
      <div class="brand-box">
        <ul class="d-flex">
          <li class="flex-fill" v-for="item in brandList" :key="item.id">
            <img
              :src="item.imgUrl"
              alt=""
            >
            <div class="brand-shade">
              <p>{{item.description}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import uuid from 'uuid/v4'
import { getCodeImg } from '@/api/common'
import { getLineImg, getPollImg } from '@/api/newsimg'
import { getNewsListStatic } from '@/api/news'
import { traceQrCode } from '@/api/tracetemplate'
export default {
  data() {
    return {
      searchForm: {
        // 6c24eff393caeadd
        traceCode: '',
        // 024120200824-1
        batchCode: '',
        imgCode: '',
        uuid: ''
      },
      slideImgs: [],
      searchFormRules: {
        traceCode: [
          { required: true, trigger: 'blur', message: '请输入溯源码' }
        ],
        batchCode: [
          { required: true, trigger: 'blur', message: '请输入批次码' }
        ],
        imgCode: [
          { required: true, trigger: 'blur', message: '请输入验证码' }
        ]
      },
      loading: false,
      codeSrc: null,
      newsList: [],
      policyList: [],
      channelList: [],
      brandList: [],
      bannerImg: ''
    }
  },
  methods: {
    initCode() {
      const __uuid = uuid()

      getCodeImg(__uuid).then((res) => {
        this.codeSrc = `data:image/gif;base64,${res.data}`
        this.searchForm.uuid = __uuid
      })
    },
    searchTrace() {
      this.$refs.refSearchForm.validate((valid) => {
        if (!valid) return
        this.loading = true
        traceQrCode({
          traceCode: this.searchForm.traceCode,
          batchCode: this.searchForm.batchCode,
          params: this.searchForm
        }).then(res => {
          if (res.status === 1) {
            if (res.data.length > 0) {
              const result = res.data[0]
              this.$alert(`<p>产品名称：${result.productName}</p><p>商品条码：${result.barcode}</p><p>批次码：${result.batchCode}</p><p>溯源码：${result.traceCode}</p>`, '溯源查询', {
                confirmButtonText: '确定',
                dangerouslyUseHTMLString: true
              })
            } else {
              this.$alert('没有查询到相应产品', '提示', {
                confirmButtonText: '确定'
              })
            }
          } else {
            this.searchForm.imgCode = null
            this.initCode()
            this.$message.error(res.msg)
          }
        })
      })
    },
    getNewsimgListData() {
      getPollImg().then(res => {
        if (res.status === 1) {
          this.slideImgs = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getBannerImg() {
      getLineImg().then(res => {
        if (res.status === 1) {
          // const result = res.data.rows[res.data.rows.length - 1]
          this.bannerImg = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 新闻列表
    getNewsListStaticData(channelCode) {
      getNewsListStatic({
        size: 5,
        channelCode: channelCode
      }).then(res => {
        if (channelCode === '001') {
          this.newsList = res.data
        } else if (channelCode === '002') {
          this.policyList = res.data
        } else if (channelCode === '003') {
          this.brandList = res.data
        }
      })
    }
  },
  mounted() {
    this.initCode()
    this.getNewsimgListData()
    this.getNewsListStaticData('001')
    this.getNewsListStaticData('002')
    this.getNewsListStaticData('003')
    this.getBannerImg()
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM')
    },
    formatDay(value) {
      return moment(value).format('DD')
    }
  }
}
</script>

<style lang="scss" scoped>
.carousel-item-img {
  width: 100%;
  height: 300px;
}

.home-module {
  width: 370px;

  &.fill {
    width: 100%;
  }

  h3,
  ul li {
    padding: 10px 0;
    border-bottom: 1px solid #ddd;
  }

  h3 {
    span.title {
      font-size: 20px;
      font-weight: bold;
    }

    .more {
      font-size: 14px;
      font-weight: normal;
      color: #787878;

      &:hover {
        color: #3b78e7;
      }
    }
  }

  ul li {
    .content {
      margin-right: 15px;
      font-size: 14px;
      color: #787878;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

    .time {
      span {
        font-size: 20px;
        color: #02a7f0;
        margin-bottom: 5px;
      }

      p {
        color: #333333;
      }
    }
  }
}

.brand-box {
  img {
    height: 370px;
    width: 300px;
  }
}
</style>
<style lang="scss">
.home-module .el-input-group--prepend .el-input__inner, .el-input-group__append {
  background: none;
  border: none;
  padding: 0;
  padding-left: 20px;
}
.brand-box li {
  position: relative;
  height: 370px;
  width: 300px;
  padding: 0!important;
  &:hover {
    .brand-shade {
      visibility:visible;
      opacity:1;
    }
  }
}
.brand-shade {
  visibility:hidden;
  opacity:0;
  transition:.5s;
  position: absolute;
  background: rgba(0,0,0, 0.5);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  align-items: center;
  display: flex;
}
.brand-shade p {
  padding: 30px;
  color: #fff;
  font-size: 12px;
  line-height: 24px;
}
</style>
